module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "page-content permission"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "lp-flex-box",
    attrs: {
      "id": "search-bar"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "输入名称查询"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.query
    }
  }, [_vm._v("查询"), _c('i', {
    staticClass: "m-icon-swapright m-icon-white"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.detail(0)
      }
    }
  }, [_vm._v("新增权限"), _c('i', {
    staticClass: "icon-plus m-icon-white"
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover table-bordered table-condensed"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.biz.items), function(item, index) {
    return _c('tr', [_c('td', {
      staticClass: "text_overflow",
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticClass: "text_overflow",
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(item.permission))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.detail(item.id)
        }
      }
    }, [_vm._v("详情")]), _vm._v("|\n            "), _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.remove(item.id)
        }
      }
    }, [_vm._v("删除")])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bar"
  }, [_c('ul', {
    staticClass: "page-breadcrumb"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  })]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("功能权限定义")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text_overflow",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticClass: "text_overflow"
  }, [_vm._v("定义")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0780ce10!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/Permission.vue
// module id = 294
// module chunks = 2 3